import sanitizeDOMData from "@/utils/sanitizeDOMData";
import { Box, createStyles, Grid, Text, Title } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  left: {
    padding: "150px",
    background: "#FFF",
    // overflow: "hidden",
    // overflowX: "hidden",
    // overflowY: " scroll",
    // Dynamic media queries, define breakpoints in theme, use anywhere
    [`@media (max-width: 1700px)`]: {
      padding: "100px",
    },
    [`@media (max-width: 1600px)`]: {
      padding: "80px",
    },
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      padding: "50px 50px 50px 50px",
    },
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      padding: "20px 20px 20px 20px",
    },
  },
  right: {
    padding: "150px",
    background: "rgba(14, 159, 153)",

    color: "#FFF",
    // Dynamic media queries, define breakpoints in theme, use anywhere
    [`@media (max-width: 1700px)`]: {
      padding: "100px",
    },
    [`@media (max-width: 1600px)`]: {
      padding: "80px",
    },
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      padding: "50px 50px 50px 50px",
    },
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      padding: "20px 20px 20px 20px",
    },
  },
  text: {
    minHeight: 300,
    marginTop: 26,
    // overflow: "none",
    overflow: "hidden",
    overflowX: "hidden",
    overflowY: "auto",
    [`::-webkit-scrollbar`]: { width: 5 },
    [`::-webkit-scrollbar-thumb`]: { background: "gray", borderRadius: 10 },
    // [`::-webkit-scrollbar-thumb:hover`]: {
    //   background: "rgba(14, 159, 153,.7)",
    // },
  },
  line: {
    height: 2,
    background: "rgba(14, 159, 153,.7)",
    width: 106,
    marginTop: 10,
  },
  lineRight: {
    height: 2,
    background: "#FFF",
    width: 106,
    marginTop: 10,
  },
}));

export default function HRTerm({
  src = "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg",
  title = "Why to choose",
  label,
  index,
}) {
  const { classes } = useStyles();
  let link = src || null;
  if (link != null) {
    if (link && link.indexOf("http") < 0) {
      link = `${process.env.server_url_report}${link}?access_token=${process.env.public_token}&trustkey=${process.env.trustkey}`;
    }
  }

  return (
    <Grid
      cols="2"
      gutter={0}
      sx={{
        backgroundImage: ` url(${link})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {index % 2 == 1 ? (
        <>
          {/* <AspectRatio ratio={1.6} sx={{ width: "100%" }}>
            <Image src={src} layout="fill" alt="hinh anh" />
          </AspectRatio> */}
          <Grid.Col xs={2} sm={3} md={4} lg={6} />
          <Grid.Col xs={10} sm={9} md={8} lg={6}>
            <Box className={classes.right}>
              <Title order={4}>{title}</Title>
              <div className={classes.lineRight} />
              <div className={classes.text}>
                <Text
                  size="lg"
                  sx={{
                    paddingTop: 10,
                  }}
                  align="justify"
                >
                  {sanitizeDOMData(label)}
                </Text>
              </div>
            </Box>
          </Grid.Col>
        </>
      ) : (
        <>
          {/* <AspectRatio ratio={1.6} sx={{ width: "100%" }}>
            <Image src={src} layout="fill" alt="hinh anh" />
          </AspectRatio> */}
          <Grid.Col xs={10} sm={9} md={6}>
            <Box className={classes.left}>
              <Title order={4}>{title}</Title>
              <div className={classes.line} />
              <div className={classes.text}>
                <Text size="lg" style={{ paddingTop: 10 }} align="justify">
                  {sanitizeDOMData(label)}
                </Text>
              </div>
            </Box>
          </Grid.Col>
          <Grid.Col xs={2} sm={3} md={6} />
        </>
      )}
    </Grid>
  );
}
